import React from "react";
import Our from "./Our/Our";

const Single = () => {
  return (
    <>
      <Our />
    </>
  );
};

export default Single;
